var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [用户信息]
 */
import decode from 'jwt-decode';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis/index';
import { EnumBusiness, EnumCooperateType, EnumUserType } from '../../enums';
import { AjaxBasics } from '../../libraries';
import { onCreateFactoryAuth } from './auth';
import { onCreateFactoryUser } from './userModel';
let UserInfoController = class UserInfoController {
    constructor() {
        /**
         * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
         * 除非是地址栏解析或者其他方式等等
         * @memberof SystemController
         */
        this.Auth = onCreateFactoryAuth();
        /**
         * 用户信息
         * @memberof SystemController
         */
        this.User = onCreateFactoryUser();
    }
    get token() {
        return this.Auth.AccessToken;
    }
    /**
     * token 解析
     * @readonly
     * @memberof SystemController
     */
    get decodeToken() {
        try {
            if (this.Auth.AccessToken) {
                return decode(this.Auth.AccessToken);
            }
        }
        catch (error) {
            console.error(error);
        }
        return {};
    }
    /** 用户身份类型 */
    get aud() {
        return lodash.get(this.decodeToken, 'aud', '');
    }
    /** 用户名 */
    get username() {
        return lodash.get(this.decodeToken, 'username', '');
    }
    /** 身份id */
    get identityId() {
        return lodash.get(this.decodeToken, 'identityId', '');
    }
    /** 姓名 */
    get realName() {
        return lodash.get(this.User.value, 'realName', '');
    }
    /** 手机号 */
    get mobile() {
        return lodash.get(this.User.value, 'mobile', '');
    }
    /** 邮箱 */
    get email() {
        return lodash.get(this.User.value, 'email', '');
    }
    /** userid */
    get userId() {
        return lodash.get(this.User.value, 'userId');
    }
    /** 角色 */
    get role() {
        return lodash.get(this.User.value, 'roleIdContent', '');
    }
    /** 渠道编码 */
    get channelId() {
        return lodash.get(this.User.value, 'channelId', '');
    }
    // 是否认证
    get isAttestation() {
        return lodash.get(this.User.value, 'verifiedStatus', false);
    }
    //是否T1身份
    get isT1() {
        return lodash.eq(this.aud, 'yzc77lqhuaostfqe');
    }
    // 是否认证或加入组织
    get isAuth() {
        return this.identityId && this.isAttestation;
    }
    /** 是否完善信息 */
    get isPerfectInfo() {
        return this.realName;
    }
    /** 是否签约 */
    get isSign() {
        return lodash.get(this.User.value, 'signingStatus', false);
    }
    /**
     * 是否k码登录
     */
    get isKCodeLogin() {
        return lodash.startsWith(lodash.toLower(this.username), lodash.toLower('k'));
    }
    // 是否是管理员
    get isAdmin() {
        const adminIdList = ['111', '119', '159', '161'];
        let role = lodash.get(this.User.value, 'roleIdContent');
        if (!role)
            return false;
        const roleList = lodash.map(role.split(','), (e) => {
            return lodash.includes(adminIdList, e);
        });
        return lodash.some(roleList, Boolean);
    }
    // b码
    get businessCode() {
        return lodash.get(this.User.value, 'companyCoreResponse.businessCode', '');
    }
    // 用户地址
    get userAddress() {
        return lodash.get(this.User.value, 'userAddress', '');
    }
    /** BU */
    get BU() {
        return lodash.get(this.User.value, 'businessType', '');
    }
    /** 是否ISG */
    get isISG() {
        return lodash.eq(this.BU, EnumBusiness.ISG);
    }
    /** 是否CON */
    get isCON() {
        return lodash.eq(this.BU, EnumBusiness.CON);
    }
    /** 是否REL */
    get isREL() {
        return lodash.eq(this.BU, EnumBusiness.REL);
    }
    /** 是否SMB */
    get isSMB() {
        /** 如果存在意向伙伴等其它身份*/
        if (this.isIntendedPartner) {
            return false;
        }
        return lodash.eq(this.BU, EnumBusiness.SMB);
    }
    /** companyName 公司名称 */
    get companyName() {
        return (lodash.get(this.User.value, 'companyName') ||
            lodash.get(this.User.value, 'companyCoreResponse.companyName') ||
            '无');
    }
    /** 用户类型 */
    get userType() {
        return this.User.value.userType;
    }
    /** 是否 Sales */
    get isSales() {
        return lodash.eq(this.userType, EnumUserType.Sales);
    }
    /** 是否 意向伙伴 */
    get isIntendedPartner() {
        return lodash.eq(this.userType, EnumUserType.Intention);
    }
    /** 是否 合作伙伴 */
    get isCooperativePartner() {
        return lodash.eq(this.userType, EnumUserType.Cooperation);
    }
    /** 合作类型 */
    get cooperateType() {
        return this.User.value.cooperateType;
    }
    /** 注册伙伴 */
    get isRegisterPartner() {
        return lodash.eq(this.cooperateType, EnumCooperateType.Registered);
    }
    /** 签约伙伴 */
    get isSignPartner() {
        return lodash.eq(this.cooperateType, EnumCooperateType.Signing);
    }
    /** 是否 L2 : 未认证、签约伙伴、未签约*/
    get isLevel2() {
        return !this.isAttestation && this.isSignPartner && !this.isSign;
    }
    /** 是否 L3 : 注册伙伴*/
    get isLevel3() {
        return this.isRegisterPartner;
    }
    /** 是否 L4 ： 签约伙伴、已签约*/
    get isLevel4() {
        return this.isSignPartner && this.isSign;
    }
    /** 是否 可以购买商品 */
    get isBus() {
        if (this.isSales) {
            return false;
        }
        return this.isLevel3 || this.isLevel4;
    }
    /** 用户类型 */
    get resellerType() {
        if (this.isSales) {
            return 'Sales';
        }
        return this.cooperateType || '未认证';
    }
    /**
   用户类型
        mobile null resellerType 签约商 => 签约未绑定手机号
        isAttestation true resellerType null =>认证未绑定k码
    */
    get userDes() {
        if (this.isSales) {
            return 'Sales';
        }
        let cooperateTypeName = '';
        if (this.cooperateType) {
            cooperateTypeName = this.isRegisterPartner ? '注册伙伴' : '签约伙伴';
        }
        if (!this.mobile && this.cooperateType) {
            return cooperateTypeName + '（未绑定手机）';
        }
        if (this.isAttestation && !this.cooperateType) {
            return '已认证（未绑定k码）';
        }
        return cooperateTypeName || '未认证';
    }
    /** 可以查看积分看板  1.注册用户 levelCode = l2  2.resellerType = ‘注册商’ */
    get isShowInte() {
        return this.isSMB && (this.isRegisterPartner || this.isLevel2);
    }
    // 注册用户 积分 levelCode= l2
    // 注册商  积分 商机  resellerType=注册商
    // 签约商  商机 resellerType=签约商
    /** 可以查看商机看板  用户等级为l3或者l4 且 1.resellerType = 签约商 或者 resellerType=注册商 */
    get isShowBusiness() {
        const isL3OrL4 = this.isLevel3 || this.isLevel4;
        const isType = this.isSignPartner || this.isRegisterPartner;
        return this.isSMB && isL3OrL4 && isType;
    }
    // 是否展示销售看板
    get isShowSales() {
        return this.isSMB && (this.isLevel3 || this.isLevel4);
    }
    // 是否展示奖励看板 - 仅签约商可看
    get isShowReward() {
        return this.isSMB && this.isLevel4;
    }
    /** des 登录用户可以查看简单版本的销售看板 - 有饼图   */
    get isShowSimpleSales() {
        // return this.User.value.token && !lodash.eq(this.User.value.resellerType,'签约商')
        return this.isSMB && this.isLevel3;
    }
    /** des  签约商可以查看完整版本销售看板  - 5个比例和 产品线 产品线暂时不做 无饼图*/
    get isShowComplexSales() {
        // return lodash.eq(this.User.value.resellerType,'签约商')
        return this.isSMB && this.isLevel4;
    }
    // 待办：CON和ISG显示
    get isShowTodo() {
        return this.isCON || this.isISG;
    }
    get isShowIndentityAction() {
        return !this.isAttestation || !this.identityId;
    }
    get isShowSignAction() {
        return this.isSMB && this.isSignPartner && !this.isSign;
    }
    // l2 且签约商 所有看板都不可看，提示 您当前帐户信息不完整，请到用户信息处维护个人信息  按钮：用户信息
    get isShowInfoAction() {
        return this.isSMB && this.isLevel2 && this.isSignPartner;
    }
    /** 用户等级 */
    get levelCode() {
        return this.User.value.levelCode || '';
    }
    get id() {
        return lodash.get(this.User.value, 'id', '');
    }
    /** 用户名称 */
    get userName() {
        if (this.Auth.AccessToken) {
            return this.realName || '未设置名称';
        }
        return '请登录';
    }
    /** 头像 */
    get avatarUrl() {
        return (this.User.value.avatarUrl ||
            'https://iconfont.alicdn.com/t/6bfa31ff-0a40-47b9-a08d-48429f2d7b7c.png');
    }
    /** 用户地址 */
    get userExtendDTO() {
        return (lodash.get(this.User.value, 'userExtendDTO', {}) ||
            lodash.get(this.User.value, 'userAddress', {}));
    }
    /** 地址Str */
    get address() {
        if (this.isSales) {
            return ' ';
        }
        const address = lodash
            .compact([
            lodash.get(this.User.value, 'userExtendDTO.province'),
            lodash.get(this.User.value, 'userExtendDTO.city'),
            lodash.get(this.User.value, 'userExtendDTO.district'),
        ])
            .join(' / ') ||
            lodash
                .compact([
                lodash.get(this.User.value, 'userAddress.province'),
                lodash.get(this.User.value, 'userAddress.city'),
                lodash.get(this.User.value, 'userAddress.district'),
            ])
                .join(' / ');
        return address || '未设置地区';
    }
    get isMobile() {
        // 不包含k码的就是手机登陆的
        const username = lodash.toLower(this.username);
        return !lodash.includes(username, 'k');
    }
    /** sales信息 */
    get salesInfo() {
        return this.User.value.salesInfo;
    }
    /** 用户城市码 */
    get cityCode() {
        return lodash.get(this.User.value, 'userAddress.cityCode', '');
    }
    /** 用户当前渠道类型子类型 */
    get channelTypeList() {
        return lodash.get(this.User.value, 'channelTypeList', []);
    }
    /** 扩展信息 获取二维码地址 */
    get weChatQrCode() {
        let weChatQrCode = '';
        const extendInfo = lodash.get(this.User.value, 'extendInfo', '');
        if (JSON.stringify(extendInfo) !== '"{}"' && lodash.size(extendInfo) > 0) {
            weChatQrCode = extendInfo[0]?.value;
        }
        return weChatQrCode;
    }
    /** ISG服务商 或者 SMB注册商 */
    get isIsgService() {
        let findIsgObj = lodash.find(this.channelTypeList, (ele) => {
            return ele.typeId == '12' && ele.subtypeId == '80';
        });
        let fidSmbObj = lodash.find(this.channelTypeList, (ele) => {
            return ele.typeId == '20';
        });
        return !lodash.isEmpty(findIsgObj) || !lodash.isEmpty(fidSmbObj);
    }
    /** 关闭展开的菜单 */
    closeEllipsis() {
        if (this.token) {
            this.User.merge({ ellipsis: false });
        }
    }
    /** 暂开扩展菜单 */
    get unfoldEllipsis() {
        return lodash.get(this.User.value, 'ellipsis', !lodash.isEmpty(this.token));
    }
    /** 获取角色信息 */
    async getRoleInfo() {
        try {
            const res = await AjaxBasics.request(EnumAPI.partner_get_identity_role);
            this.User.merge({ role: res });
            return res;
        }
        catch (error) { }
    }
    /** 获取登录身份信息 */
    async getIdentityInfo() {
        try {
            const res = await AjaxBasics.request(EnumAPI.partner_get_identity_info);
            this.User.merge(res);
            return res;
        }
        catch (error) { }
    }
    /** 获取用户信息 */
    async getUserInfo() {
        try {
            const res = await AjaxBasics.request({ ...EnumAPI.idass_get_userinfo });
            this.User.merge(res);
            return res;
        }
        catch (error) { }
    }
    /** 获取企业认证信息 */
    async getCompanyInfo() {
        try {
            const res = await AjaxBasics.request(EnumAPI.company_auth_token);
            if (res) {
                this.User.merge(res);
                return res;
            }
        }
        catch (error) { }
    }
    /**
     * @descriptions 获取文件中心授权码，无时效性
     * @params
     */
    async getFileCode() {
        return await AjaxBasics.request(EnumAPI.idass_get_file_code);
    }
    /**
     *  上传头像
     * @param entity
     * @returns
     */
    async updateAvatar(entity) {
        const authorizeCode = await this.getFileCode();
        try {
            return await AjaxBasics.request(lodash.assign({}, EnumAPI.bffsvr_updateAvatar, {
                url: `${EnumAPI.bffsvr_updateAvatar.url}/${authorizeCode}`,
                body: entity,
            }));
            // this.User.merge({ avatarUrl: queryParams.headPortraitUrl });
        }
        catch (error) { }
    }
    /**
     *  保存用户信息
     * @param entity
     * @returns
     */
    async updateInfo(values) {
        try {
            return await AjaxBasics.request({
                ...EnumAPI.idass_update_userinfo,
                body: values,
            });
        }
        catch (error) { }
    }
    /** 刷新身份 */
    async identityRefresh() {
        try {
            const res = await AjaxBasics.request(EnumAPI.accountsvr_refresh_indentity);
            if (!res) {
                return false;
            }
            this.Auth.onSaveAccessToken(lodash.get(res, 'idToken'));
            throw '刷新页面';
        }
        catch (error) {
            if (!lodash.eq(error, '刷新页面')) {
                await this.Auth.onClear();
            }
            throw error;
        }
    }
    /** 切换身份 */
    async identitySwitch(body) {
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.accountsvr_identity_switch,
                body,
            });
            if (!res) {
                return false;
            }
            this.Auth.onSaveAccessToken(lodash.get(res, 'idToken'));
            throw '刷新页面';
        }
        catch (error) {
            if (!lodash.eq(error, '刷新页面')) {
                await this.Auth.onClear();
            }
            throw error;
        }
    }
};
__decorate([
    computed
], UserInfoController.prototype, "token", null);
__decorate([
    computed
], UserInfoController.prototype, "decodeToken", null);
__decorate([
    computed
], UserInfoController.prototype, "aud", null);
__decorate([
    computed
], UserInfoController.prototype, "username", null);
__decorate([
    computed
], UserInfoController.prototype, "identityId", null);
__decorate([
    computed
], UserInfoController.prototype, "realName", null);
__decorate([
    computed
], UserInfoController.prototype, "mobile", null);
__decorate([
    computed
], UserInfoController.prototype, "email", null);
__decorate([
    computed
], UserInfoController.prototype, "userId", null);
__decorate([
    computed
], UserInfoController.prototype, "role", null);
__decorate([
    computed
], UserInfoController.prototype, "channelId", null);
__decorate([
    computed
], UserInfoController.prototype, "isAttestation", null);
__decorate([
    computed
], UserInfoController.prototype, "isT1", null);
__decorate([
    computed
], UserInfoController.prototype, "isAuth", null);
__decorate([
    computed
], UserInfoController.prototype, "isPerfectInfo", null);
__decorate([
    computed
], UserInfoController.prototype, "isSign", null);
__decorate([
    computed
], UserInfoController.prototype, "isKCodeLogin", null);
__decorate([
    computed
], UserInfoController.prototype, "isAdmin", null);
__decorate([
    computed
], UserInfoController.prototype, "businessCode", null);
__decorate([
    computed
], UserInfoController.prototype, "userAddress", null);
__decorate([
    computed
], UserInfoController.prototype, "BU", null);
__decorate([
    computed
], UserInfoController.prototype, "isISG", null);
__decorate([
    computed
], UserInfoController.prototype, "isCON", null);
__decorate([
    computed
], UserInfoController.prototype, "isREL", null);
__decorate([
    computed
], UserInfoController.prototype, "isSMB", null);
__decorate([
    computed
], UserInfoController.prototype, "companyName", null);
__decorate([
    computed
], UserInfoController.prototype, "userType", null);
__decorate([
    computed
], UserInfoController.prototype, "isSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isIntendedPartner", null);
__decorate([
    computed
], UserInfoController.prototype, "isCooperativePartner", null);
__decorate([
    computed
], UserInfoController.prototype, "cooperateType", null);
__decorate([
    computed
], UserInfoController.prototype, "isRegisterPartner", null);
__decorate([
    computed
], UserInfoController.prototype, "isSignPartner", null);
__decorate([
    computed
], UserInfoController.prototype, "isLevel2", null);
__decorate([
    computed
], UserInfoController.prototype, "isLevel3", null);
__decorate([
    computed
], UserInfoController.prototype, "isLevel4", null);
__decorate([
    computed
], UserInfoController.prototype, "isBus", null);
__decorate([
    computed
], UserInfoController.prototype, "resellerType", null);
__decorate([
    computed
], UserInfoController.prototype, "userDes", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowInte", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowBusiness", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowReward", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowSimpleSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowComplexSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowTodo", null);
__decorate([
    computed
], UserInfoController.prototype, "levelCode", null);
__decorate([
    computed
], UserInfoController.prototype, "id", null);
__decorate([
    computed
], UserInfoController.prototype, "userName", null);
__decorate([
    computed
], UserInfoController.prototype, "avatarUrl", null);
__decorate([
    computed
], UserInfoController.prototype, "userExtendDTO", null);
__decorate([
    computed
], UserInfoController.prototype, "address", null);
__decorate([
    computed
], UserInfoController.prototype, "isMobile", null);
__decorate([
    computed
], UserInfoController.prototype, "salesInfo", null);
__decorate([
    computed
], UserInfoController.prototype, "cityCode", null);
__decorate([
    computed
], UserInfoController.prototype, "channelTypeList", null);
__decorate([
    computed
], UserInfoController.prototype, "weChatQrCode", null);
__decorate([
    computed
], UserInfoController.prototype, "unfoldEllipsis", null);
UserInfoController = __decorate([
    BindAll()
], UserInfoController);
export { UserInfoController };
